import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import actions from "@/store/shardActions";
import Home from "../views/Home.vue";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "*",
    name: "Home",
    // component: () => import("../views/Home.vue"),
    component: Home,
  },
  {
    path: "/forceBind",
    name: "ForceBind",
    component: () => import("../views/ForceBind.vue"),
  },
  {
    path: "/googleLogin",
    name: "GoogleLogin",
    component: () => import("../views/GoogleLogin.vue"),
  },
];
const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.length === 0) {
    next();
  } else {
    let token = actions.getGlobalState("accessToken");
    if (token && token.length > 0) {
      if (to.name == "Login") {
        next({ name: "Home" });
      } else if (to.name == "ForceBind") {
        if (to.params.username && to.params.username.length > 0) {
          next();
        } else {
          actions.setGlobalState({
            accessToken: "",
            //commonData修改
            dataUpdate: false,
            // 当前用户信息
            currentUser: "",
            // 当前用户权限树
            permissionTree: "",
            // 获取token报错
            getTokenError: false,
            //当前客户
            currentCustomer: "",
            //当前门店
            currentStore: "",
            //控制菜单  隐藏显示
            showMenu: true,
            // 公共客户门店数据
            commonData: {},
            currentAppName: "",
          });
          localStorage.removeItem("loginResponse");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("user");
          next({ name: "login" });
        }
      } else {
        next();
      }
    } else {
      if (to.name == "Login") {
        next();
      } else {
        next({ name: "Login" });
      }
    }
  }
});

export default router;
